// @flow
export const TOP_DEALS_REQUESTED: "TOP_DEALS_REQUESTED" = "TOP_DEALS_REQUESTED";
export const TOP_DEALS_SUCCEEDED: "TOP_DEALS_SUCCEEDED" = "TOP_DEALS_SUCCEEDED";
export const TOP_DEALS_FAILED: "TOP_DEALS_FAILED" = "TOP_DEALS_FAILED";

export const TOP_DEAL_REQUESTED: "TOP_DEAL_REQUESTED" = "TOP_DEAL_REQUESTED";
export const TOP_DEAL_SUCCEEDED: "TOP_DEAL_SUCCEEDED" = "TOP_DEAL_SUCCEEDED";
export const TOP_DEAL_FAILED: "TOP_DEAL_FAILED" = "TOP_DEAL_FAILED";
